import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ParticleBackground from "./components/ParticleBackground";
import Header from "./components/Header";
import Footer from "./components/Footer";
import usePageTracker from "./hooks/usePageTracker";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Experience from "./pages/Experience";
import Education from "./pages/Education";
import Awards from "./pages/Awards";
import Publications from "./pages/Publications";
import Contact from "./pages/Contact";
import Analytics from "./pages/Analytics";

function PageTracker() {
  usePageTracker();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <ParticleBackground />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/education" element={<Education />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/analytics" element={<Analytics />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
